const STATS = [
    { k: "ROBOTS BUILT", v: "01-ish", cls: "text-cyan-700", big: true },
    { k: "DOMAINS PURCHASED", v: "MORE THAN NECESSARY", cls: "text-slate-900" },
    { k: "APIs CONNECTED", v: "CONCERNING", cls: "text-amber-600" },
    { k: "IDEAS ABANDONED", v: "HEALTHY AMOUNT", cls: "text-slate-600" },
    { k: "PROJECTS STARTED AT SENSIBLE HOURS", v: "0", cls: "text-slate-500", big: true },
    { k: "TIMES \u201CTHIS SHOULD WORK\u201D WAS SAID", v: "DATA UNAVAILABLE", cls: "text-slate-500" },
    { k: "VENTURE CAPITAL RAISED", v: "$0", cls: "text-emerald-600", big: true },
    { k: "MEETINGS HELD", v: "ALMOST NONE", cls: "text-slate-600" },
    { k: "POWERPOINT DECKS CREATED FOR INVESTORS", v: "0", cls: "text-slate-500", big: true },
    { k: "THINGS ACTUALLY BUILT", v: "> 0", cls: "text-cyan-700", big: true },
];

export default function TelemetrySection() {
    return (
        <section id="telemetry" className="py-20 border-b border-subtle bg-[#e9edf1]" data-testid="telemetry-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-4">
                    <div>
                        <span className="font-mono text-xs text-cyan-600 tracking-widest uppercase">
                            // Rigorous Lab Audit
                        </span>
                        <h2 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-1">
                            Laboratory Statistics
                        </h2>
                    </div>
                    <span className="font-mono text-[11px] text-slate-500">
                        AUDIT METHOD: SELF-REPORTED // VERIFICATION: NONE
                    </span>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 font-mono text-xs">
                    {STATS.map((s, i) => (
                        <div
                            key={s.k}
                            data-testid={`stat-card-${i + 1}`}
                            className="p-5 rounded bg-white border border-subtle flex flex-col justify-between min-h-[110px] hover:border-cyan-500/30 transition-colors duration-300"
                        >
                            <span className="text-slate-500 block text-[10px] leading-snug">
                                <span className="inline-block h-1 w-1 rounded-full bg-cyan-500/70 animate-led mr-1.5 align-middle" />
                                {s.k}
                            </span>
                            <span className={`${s.big ? "text-2xl" : "text-base"} font-bold ${s.cls} mt-3 block`}>
                                {s.v}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
